// extracted by mini-css-extract-plugin
export default {"tips":"Tips_tips__r0qbI","icon":"Tips_icon__vkeIN"};